import { render, staticRenderFns } from "./CodeOfPractice.vue?vue&type=template&id=e2189700&scoped=true&"
import script from "./CodeOfPractice.vue?vue&type=script&lang=js&"
export * from "./CodeOfPractice.vue?vue&type=script&lang=js&"
import style0 from "./CodeOfPractice.vue?vue&type=style&index=0&id=e2189700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2189700",
  null
  
)

export default component.exports